// The design editor loads one translation bundle per locale below; any other value 404s and
// silently falls back to English, so an OP locale without its own bundle takes the one for its language.
const EDITOR_LOCALES = [
  'cs-CZ',
  'da-DK',
  'de-DE',
  'en',
  'es-ES',
  'fr-FR',
  'it-IT',
  'ja-JP',
  'nb-NO',
  'nl-NL',
  'pl-PL',
  'pt-BR',
  'pt-PT',
  'sv-SE',
  'vi-VN',
];

// OP language subtags that the editor spells differently.
const languageAliases: { [opLanguage: string]: string } = {
  no: 'nb',
  dk: 'da',
};

const DEFAULT_EDITOR_LOCALE = 'en';

// Where the editor ships several bundles for one language, the one a market without its own should get.
const preferredByLanguage: { [language: string]: string } = {
  pt: 'pt-PT',
};

const getLanguage = (locale: string) => {
  const language = locale.split('-')[0].toLowerCase();

  return languageAliases[language] || language;
};

const mapLocaleToEditorSupported = (opLocale: string) => {
  // The integration layer is host-supplied, so the locale can be absent; English is the editor's
  // own fallback and the editor has to boot either way.
  if (!opLocale) {
    return DEFAULT_EDITOR_LOCALE;
  }

  if (EDITOR_LOCALES.indexOf(opLocale) !== -1) {
    return opLocale;
  }

  const language = getLanguage(opLocale);
  const preferred = preferredByLanguage[language];

  if (preferred && EDITOR_LOCALES.indexOf(preferred) !== -1) {
    return preferred;
  }

  return EDITOR_LOCALES.find((editorLocale) => getLanguage(editorLocale) === language)
    || DEFAULT_EDITOR_LOCALE;
};

export default mapLocaleToEditorSupported;
